// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OZJ2","textarea":"styles_textarea__1QM5j"};